import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import LogoDark from "../../assets/imgs/logo2.png";
import LogoLight from "../../assets/imgs/logo_light.svg";
import "./auth.css";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { handlePostRequest } from "../../services/PostTemplate";

const RegisterUser = () => {
    const [saveBtnLoading, setSaveBtnLoading] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        email: Yup.mixed().required("This field is required."),
        password: Yup.mixed().required("This field is required."),
        firstName: Yup.mixed().required("This field is required."),
        lastName: Yup.mixed().required("This field is required."),
        mobile: Yup.mixed().required("This field is required."),
        email: Yup.mixed().required("This field is required."),
        cnic: Yup.mixed().required("This field is required."),
        password: Yup.mixed().required("This field is required."),
        confirmPassword: Yup.mixed().required("This field is required."),
        gender: Yup.mixed().required("This field is required."),
        userType: Yup.mixed().required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            firstName: "",
            lastName: "",
            mobile: "",
            email: "",
            cnic: "",
            password: "",
            confirmPassword: "",
            gender: "",
            userType: "",
            inviteCode: "",
            corporateCode: "",
        },

        onSubmit: async (data) => {
            setSaveBtnLoading(true);
            try {
                if (formik.values.password === formik.values.confirmPassword) {
                    const payload = {
                        firstName: data?.firstName,
                        lastName: data?.lastName,
                        mobile: data?.mobile,
                        email: data?.email,
                        cnic: data?.cnic,
                        password: data?.password,
                        gender: data?.gender,
                        userType: data?.userType,
                        device: "WebApp", // Include signupDevice in the payload
                    };

                    console.log("payload", payload);

                    const response = await dispatch(handlePostRequest("api/user/register", payload, true, true));
                    if (response) {
                        formik.resetForm();
                    }
                    setSaveBtnLoading(false);
                } else {
                    setSaveBtnLoading(false);
                    toast.warn("Password and Confirm Password doesn't match");
                }
            } catch (error) {
                console.log(error);
                setSaveBtnLoading(false);
            }
        },
    });

    const userTypeLov = [
        { name: "Owner", value: 1 },
        { name: "Passenger", value: 2 },
    ];

    const genderLov = [
        { name: "Male", value: "male" },
        { name: "Female", value: "female" },
    ];

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="flex login-main-body align-items-center justify-content-center min-h-screen  overflow-hidden">
                    <div className="register-div-border">
                        <div className="w-full surface-card py-5 px-5 sm:px-6">
                            <div className="text-center mb-5">
                                <img src={true ? LogoLight : LogoDark} alt="Image" height="80" className="w-18rem mb-5" />
                                <div className="text-3xl font-medium mb-3" style={{ color: "whitesmoke" }}>
                                    Register Account
                                </div>
                                {/* <span className="text-600 font-medium">Sign up to continue</span> */}
                            </div>

                            <div className="grid mx-0 justify-content-center w-full">
                                <div className="grid py-1 col-12">
                                    <div className="col-12 sm:col-6">
                                        <InputText id="firstName" name="firstName" type="text" placeholder="Enter First Name" value={formik?.values?.firstName} onChange={formik?.handleChange} className="w-full" />
                                        {getFormErrorMessage("firstName")}
                                    </div>

                                    <div className="col-12 sm:col-6">
                                        <InputText id="lastName" name="lastName" type="text" placeholder="Enter Last Name" value={formik?.values?.lastName} onChange={formik?.handleChange} className="w-full" />
                                        {getFormErrorMessage("lastName")}
                                    </div>
                                </div>

                                <div className="grid py-1 col-12">
                                    <div className="col-12 sm:col-6">
                                        <InputText id="mobile" name="mobile" placeholder="Enter Phone No." value={formik?.values?.mobile} onChange={formik.handleChange} type="tel" className="w-full " />
                                        {getFormErrorMessage("mobile")}
                                    </div>

                                    <div className="col-12 sm:col-6">
                                        <InputText id="email" name="email" placeholder="Enter Email" value={formik.values.email} onChange={formik.handleChange} type="email" className="w-full " />
                                        {getFormErrorMessage("email")}
                                    </div>
                                </div>

                                <div className="grid py-1 col-12">
                                    <div className="col-12 sm:col-6">
                                        <InputText id="cnic" name="cnic" placeholder="Enter CNIC/ID" value={formik.values.cnic} onChange={formik.handleChange} type="number" className="w-full " />
                                        {getFormErrorMessage("cnic")}
                                    </div>

                                    <div className="col-12 sm:col-6">
                                        <InputText id="password" name="password" placeholder="Enter Password" value={formik.values.password} onChange={formik.handleChange} type="password" className="w-full " />
                                        {getFormErrorMessage("password")}
                                    </div>
                                </div>

                                <div className="grid py-1 col-12">
                                    <div className="col-12 sm:col-6">
                                        <InputText id="confirmPassword" name="confirmPassword" placeholder="Enter Confirm Password" value={formik.values.confirmPassword} onChange={formik.handleChange} type="password" className="w-full " />
                                        {getFormErrorMessage("confirmPassword")}
                                    </div>

                                    <div className="col-12 sm:col-6">
                                        <Dropdown id="userType" name="userType" placeholder="--Select User Type--" options={userTypeLov} optionLabel="name" optionValue="value" value={formik.values.userType} onChange={formik.handleChange} className="w-full " />
                                        {getFormErrorMessage("userType")}
                                    </div>
                                </div>

                                <div className="grid py-1 col-12">
                                    <div className="col-12 sm:col-6">
                                        <Dropdown id="gender" name="gender" placeholder="--Select Gender--" options={genderLov} optionLabel="name" optionValue="value" value={formik.values.gender} onChange={formik.handleChange} className="w-full " />
                                        {getFormErrorMessage("gender")}
                                    </div>
                                </div>

                                <div className="grid py-1 col-12">
                                    <div className="col-12 sm:col-6">
                                        <InputText id="inviteCode" name="inviteCode" placeholder="Invite Code RHPR" value={formik.values.inviteCode} onChange={formik.handleChange} type="text" className="w-full " />
                                    </div>

                                    <div className="col-12 sm:col-6">
                                        <InputText id="corporateCode" name="corporateCode" placeholder="Enter Corporate Code" value={formik.values.corporateCode} onChange={formik.handleChange} type="text" className="w-full " />
                                    </div>
                                </div>

                                <div className=" col-12 mb-2 mt-5">
                                    <Button label="Sign Up" loading={saveBtnLoading} type="submit" className="w-full text-xl p-3" />
                                </div>
                                <span className="mr-3" style={{ color: "var(--text-color)", float: "right" }}>
                                    {" "}
                                    Already have an account ?{" "}
                                    <span style={{ color: "white", cursor: "pointer" }} onClick={() => history.push("/")}>
                                        {" "}
                                        Login Please{" "}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
};

export default RegisterUser;
